import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"elevation-4",attrs:{"outlined":_vm.$vuetify.theme.isDark,"color":"secondary","dark":"","max-width":"500px"}},[_c(VCardText,[_c(VFlex,{staticClass:"text-center white--text",attrs:{"xs12":""}},[_vm._v("\n      "+_vm._s(_vm.loadingText)+"...\n    ")]),_c(VFlex,{staticClass:"mt-2 text-center",attrs:{"xs12":""}},[_c(VProgressCircular,{attrs:{"size":70,"width":7,"color":"white","indeterminate":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }